import React from "react";
import LegalLayout from "./LegalLayout";

const UPDATED = "3 July 2026";

export default function Refund() {
  return (
    <LegalLayout title="Refund & Cancellation Policy" updated={UPDATED}>
      <Section title="Free trial">
        <p>
          The free trial is a one-time, no-cost allowance per workspace — 1 brand import and 1
          Find-Customers scan (view-only). It is not a recurring free plan and there is nothing to
          cancel; you can stop using the Service at any time. Deleting your account removes your
          data within 30 days.
        </p>
      </Section>

      <Section title="Starter plan (monthly subscription)">
        <p>
          The Starter plan is a monthly subscription priced at INR 1,999 per month (inclusive of
          GST) via Razorpay, or USD 19.99 per month via Stripe. Because you get access to a paid
          AI-powered service the moment you pay, we follow a{" "}
          <strong>7-day satisfaction refund</strong> policy on your first payment:
        </p>
        <ul>
          <li>
            You may request a full refund within <strong>7 calendar days</strong> of your first
            payment, for any reason, provided you have used fewer than 5 scans in that billing
            period.
          </li>
          <li>
            If you have used 5 or more scans in the billing period, or if 7 days have passed
            since payment, that month's charge is final and non-refundable.
          </li>
          <li>
            You can cancel at any time from your billing settings; cancellation stops future
            renewals and your access continues until the end of the current billing period.
            Renewal charges after the first month are not refundable.
          </li>
          <li>
            Refunds are processed to the original payment method within 7-10 business days.
            Razorpay refunds settle to the same bank/UPI/card used at checkout. Stripe refunds
            settle to the same card.
          </li>
          <li>
            Chargeback or dispute filings will result in immediate suspension of the subscription
            while the dispute is resolved.
          </li>
        </ul>
      </Section>

      <Section title="Fair-use suspensions">
        <p>
          If your workspace is suspended for a violation of our{" "}
          <a href="/terms" className="text-lm-primary underline underline-offset-4">
            Terms of Service
          </a>{" "}
          (e.g. scraping our results in bulk, sharing credentials across many operators), the
          current subscription period is forfeited and is not refundable.
        </p>
      </Section>

      <Section title="Service sunset">
        <p>
          If we ever discontinue the Service, active subscribers will be notified at least
          90 days in advance and will receive a pro-rated goodwill credit or refund at our sole
          discretion.
        </p>
      </Section>

      <Section title="How to request a refund">
        <p>
          Email{" "}
          <a href="mailto:support@aifreedomclub.com" className="text-lm-primary underline underline-offset-4">
            support@aifreedomclub.com
          </a>{" "}
          from the same email address you used to purchase, with your payment ID (from your
          receipt) and a short note on why you'd like the refund. We will acknowledge within 2
          business days and process eligible refunds within 7 business days after that.
        </p>
      </Section>

      <Section title="Contact">
        <p>
          Billing:{" "}
          <a href="mailto:support@aifreedomclub.com" className="text-lm-primary underline underline-offset-4">
            support@aifreedomclub.com
          </a>
          <br />
          General support:{" "}
          <a href="mailto:support@aifreedomclub.com" className="text-lm-primary underline underline-offset-4">
            support@aifreedomclub.com
          </a>
        </p>
      </Section>
    </LegalLayout>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-8">
      <h2 className="font-display font-semibold text-xl md:text-2xl tracking-tight text-lm-text mb-3">
        {title}
      </h2>
      <div className="text-lm-text2 space-y-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_a]:text-lm-primary [&_a]:underline [&_a]:underline-offset-4">
        {children}
      </div>
    </section>
  );
}
